<template>
    <b-dropdown right variant="primary" :size="size || 'sm'" :text="t.actions.generateUrl" @show="generateInviteUrl">
        <b-dropdown-form>
            <label>{{t['url-generation-info']}}</label>
            <b-input-group size="sm">
                <b-input ref="input" readonly type="text" :value="link" @focus="inputFocused"></b-input>
                <b-input-group-append>
                    <b-button @click="copyButtonClicked"><fa-icon icon="copy"></fa-icon></b-button>
                </b-input-group-append>
            </b-input-group>
        </b-dropdown-form>
    </b-dropdown>
</template>

<script>
import {request} from '../../api'

export default {
    name: "InviteUrlGenerator",
    props: ['t', 'url', 'size'],
    data: () => ({
        link: ''
    }),
    methods: {
        async generateInviteUrl() {
            const response = await request(this.url, {method: 'GET'})
            this.link = await response.text()
        },
        inputFocused() {
            this.$refs.input.select()
        },
        copyButtonClicked() {
            this.$refs.input.focus()
            document.execCommand("copy");
        }
    }
}
</script>

<style scoped>
</style>
